/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';
import {
	Label,
	VSpacer,
	FlexItem,
	FlexLayout,
	TextInput
} from '@ba/ba-ui-carbon-toolkit';
import '../../../stylesheets/all.scss';

export default class ItemDetail extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		fileRef: PropTypes.string.isRequired,
		updateItemCallback: PropTypes.func.isRequired,
		index: PropTypes.number.isRequired,
		selectionCount: PropTypes.number.isRequired
	};

	constructor(props) {
		super(props);
	}

	/* componentWillReceiveProps(nextProps) {
	} */

	renderCountSelection() {
		const { selectionCount } = this.props;

		let label = selectionCount === 0 ? StringResources.get('schematicsNoSelection') :
			StringResources.get('schematicsMultipleSelection', { count: selectionCount } );
		return (
			<FlexLayout
				direction='column'
				width='100%'
				height='100%'
				alignItems='center'
				justifyContent='center'
				className="clsSVGDetailContainer"
			>
				<FlexItem>
					<Label type='caption' label={label} />
				</FlexItem>
			</FlexLayout>);
	}

	renderSingleSelection() {
		const { item, index, fileRef } = this.props;

		let nameLabel = StringResources.get('nameLabelSchematic');
		let captionLabel = StringResources.get('captionLabelSchematic');
		let keyLabel = StringResources.get('keyLabelSchematic');

		let sourceUrl = fileRef;
		let source = item.source;
		let caption = item.caption;
		let key = item.key;

		return (
			<FlexLayout
				direction='column'
				width='100%'
				height='100%'
				alignItems='center'
				className="clsSVGDetailContainer"
			>
				<FlexItem>
					<FlexLayout
						direction='column'
						alignItems='center'
						justifyContent='center'
						className='clsSVGDetailStyle'
					>
						<FlexItem style={{ width:'100%' }} >
							<FlexItem>
								{item && <img style={{ width:'100%', height:'auto', maxWidth:'237px', maxHeight:'216px' }} src={sourceUrl} />}
							</FlexItem>
						</FlexItem>
					</FlexLayout>
				</FlexItem>
				<FlexItem>
					<VSpacer size={2} />
				</FlexItem>
				<FlexItem style={{ width:'100%', height:'24px' }} >
					<Label type='caption' htmlFor='nameEdit' label={nameLabel} />
				</FlexItem>
				<FlexItem className="clsSVGDetailEdit">
					<TextInput
						id='nameEdit'
						value={source}
						disabled={true} />
				</FlexItem>
				<FlexItem>
					<VSpacer size={2} />
				</FlexItem>

				<FlexItem style={{ width:'100%', height:'24px' }} >
					<Label type='caption' htmlFor='captionEdit' label={captionLabel} />
				</FlexItem>
				<FlexItem className="clsSVGDetailEdit">
					<TextInput
						id='captionEdit'
						value={caption}
						onValueChange={v => {
							this.props.updateItemCallback('caption', v, index);
						}}
					/>
				</FlexItem>

				<FlexItem>
					<VSpacer size={2} />
				</FlexItem>

				<FlexItem style={{ width:'100%', height:'24px' }} >
					<Label type='caption' htmlFor='keyEdit' label={keyLabel} />
				</FlexItem>
				<FlexItem className="clsSVGDetailEdit">
					<TextInput
						id='keyEdit'
						value={key}
						onValueChange={v => {
							this.props.updateItemCallback('key', v, index);
						}}
					/>
				</FlexItem>

			</FlexLayout> );
	}

	render () {
		const { selectionCount } = this.props;

		if ( selectionCount === 1 )
			return this.renderSingleSelection();
		return this.renderCountSelection();
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/schematic/ItemDetail.js